import { useState } from 'react';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Typography } from 'src/app/components/Elements/Typography';
import { segmentTrack } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';
import { formatHours } from 'src/app/utils/facilityHours';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import {
  CardContent,
  CheckIconWrapper,
  ContactContainer,
  ContactInfo,
  ContactSection,
  CopyIconWrapper,
  FacilityInfo,
  FixedWidthTypography,
  HorziontallyCenteredTypography,
  StyledCard,
} from './styles';

const EHRInfoCard = ({ facility, clearZipField }) => {
  const formattedHours = formatHours(facility.hours);
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);
  const dispatch = useDispatch();

  const handleCardClick = () => {
    if (!isCopiedToClipboard && facility?.address?.name) {
      setIsCopiedToClipboard(true);
      setTimeout(() => {
        setIsCopiedToClipboard(false);
      }, 2000);
      clearZipField();
      dispatch(segmentTrack(UNIFIED.copyCapsulePharmacyAddress, { pagepath: window.location.pathname }));
      navigator.clipboard.writeText(facility.address.name);
    }
  };

  return (
    <StyledCard>
      <CardContent onClick={handleCardClick} isCopied={isCopiedToClipboard}>
        {!isCopiedToClipboard && (
          <>
            <CheckIconWrapper iconString={CAPSULE_ICON_STRINGS.check_circle} block raw />
            <FacilityInfo>
              <Typography variant={'overline'} color={'capsuleGreen50'} marginBottom={'s3'}>
                PATIENT IS ELIGIBLE — EHR INFO
              </Typography>
              <Typography variant={'h2'} marginBottom={'s3'} color={'white'}>
                {facility?.address?.name}
                <CopyIconWrapper iconString={CAPSULE_ICON_STRINGS.copy_icon} />
                <br />
                {facility?.address?.address}, {facility?.address?.addressTwo ? `${facility.address.addressTwo}, ` : ''}
                {facility?.address?.city}, {facility?.address?.state} {facility?.address?.zipCode}
              </Typography>
              <ContactInfo>
                <ContactSection>
                  <ContactContainer>
                    {Object.keys(formattedHours).map(key => {
                      return (
                        <FixedWidthTypography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                          {key}:&nbsp;
                        </FixedWidthTypography>
                      );
                    })}
                  </ContactContainer>
                  <ContactContainer>
                    {Object.values(formattedHours).map(val => {
                      return (
                        <Typography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                          {val}
                        </Typography>
                      );
                    })}
                  </ContactContainer>
                </ContactSection>
                <ContactSection>
                  <FixedWidthTypography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                    Phone:&nbsp;
                  </FixedWidthTypography>
                  <Typography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                    {facility?.phone}
                  </Typography>
                </ContactSection>
                <ContactSection>
                  <FixedWidthTypography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                    Fax:&nbsp;
                  </FixedWidthTypography>
                  <Typography variant={'small'} color={'capsuleGreen50'} marginBottom={'none'}>
                    {facility?.fax}
                  </Typography>
                </ContactSection>
              </ContactInfo>
            </FacilityInfo>
          </>
        )}
        {isCopiedToClipboard && (
          <HorziontallyCenteredTypography variant={'h2'} color={'white'}>
            Facility name copied
          </HorziontallyCenteredTypography>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default EHRInfoCard;
